/**
 * Canonical project slugs across the monorepo.
 *
 * Every text field that says `project` (incidents, monitors, scenarios,
 * vendor_status, deploy feed, oncall_schedule, oncall_default, etc.) should
 * carry one of these values. Validate with `isValidProject()` at write sites.
 *
 * Path A (current) — string + enum. Path B (later) — promote to a `projects`
 * table with metadata (owner, slack channel, sentry org). See
 * brain/aix-command-center/feature-specs/incident-management.md.
 */
export enum EProject {
  VIDMAX = "vidmax",
  AIX_COMMAND_CENTER = "aix-command-center",
  AIXINTERNAL = "aixinternal",
  LUNCHBREAK = "lunchbreak",
  PEBBLE = "pebble",
  LOCUS = "locus",
  SAAS_ENGINE = "saas-engine",
  RENTCAPITAL = "rentcapital",
  AGENCY = "agency",
  UNTANGLE = "untangle",
  LUMI = "lumi",
  GHOST = "ghost",
  RM_WEB = "rm-web",
  NEXTJS_STARTER = "nextjs-starter",
}

export const ALL_PROJECTS: readonly EProject[] = Object.values(EProject)

export function isValidProject(value: string | null | undefined): value is EProject {
  if (!value) return false
  return (ALL_PROJECTS as readonly string[]).includes(value)
}

export function assertValidProject(value: string | null): asserts value is EProject | null {
  if (value === null) return
  if (!isValidProject(value)) {
    throw new Error(`Invalid project slug: "${value}". Valid: ${ALL_PROJECTS.join(", ")}`)
  }
}
